import { Component } from '@angular/core';
import { PinShapeSvg } from './pin-shape-svg';

@Component({
  selector: 'topo-square-svg',
  standalone: true,
  template: `
    <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" rx="3" width="24" height="24" [attr.fill]="color()" />
    </svg>
  `
})
export class SquareSvgComponent extends PinShapeSvg {}
